/* Quick add: show sold-out colourways, and refuse to add one.

   THE BUG
   The quick-add drawer let a shopper pick a sold-out colourway and press
   Add to bag as if it were in stock. Astro, for example, is sold out in all
   four colourways, and the drawer showed four ordinary swatches above a live
   button. The product page has said "Sold out" on its swatches since the
   diagonal was added; the drawer never learned.

   WHY A SEPARATE FILE
   The drawer is rendered inside the minified sf-claude.js. Rather than edit
   generated code, this watches the drawer and corrects it after each render.
   If the renderer changes, this stops finding the swatches and does nothing
   — the drawer keeps working as it does today.

   HOW THE OPEN FAMILY IS IDENTIFIED
   The drawer carries no family handle, only swatches with data-i indexes.
   The first swatch's IMAGE URL is matched against the catalogue already
   embedded in the page, which pins the family exactly — titles would break
   on any family whose colour words repeat, and the View link points at a
   product rather than the family.

   THE DIAGONAL IS THE ONE ALREADY IN USE on product pages, so a sold-out
   colourway looks the same wherever a shopper meets it.
*/
(function(){
"use strict";

function data(){
  try { return JSON.parse(document.getElementById('sf-data').textContent) || {}; }
  catch(e){ return {}; }
}

/* The family whose products match the swatches currently rendered. */
function openFamily(row){
  var d = data();
  var firstImg = row.children[0] && row.children[0].querySelector('img');
  if(!firstImg) return null;
  var src = (firstImg.getAttribute('src') || '').split('?')[0];
  if(!src) return null;

  var fams = d.families || [];
  for(var i=0;i<fams.length;i++){
    var ps = fams[i].products || [];
    if(ps.length !== row.children.length) continue;
    var head = (ps[0].img || '').split('?')[0];
    if(head && head === src) return fams[i];
  }
  return null;
}

function soldOutWord(){
  return document.documentElement.lang === 'ar' ? 'نفذت الكمية' : 'Sold out';
}

function apply(){
  var row = document.getElementById('qSw');
  var add = document.getElementById('qAdd');
  if(!row || !add || !row.children.length) return;

  var fam = openFamily(row);
  if(!fam) return;

  /* Mark each sold-out swatch. The class is the same one the product page
     uses, so the diagonal and the struck-through label come for free. */
  var kids = row.children;
  for(var i=0;i<kids.length;i++){
    var p = fam.products[i];
    if(!p) continue;
    var el = kids[i];
    if(p.available){
      el.classList.remove('out');
      el.removeAttribute('data-soldout');
    } else {
      el.classList.add('out');
      el.setAttribute('data-soldout','1');
      /* Spoken for screen readers, not only drawn. */
      var lab = el.getAttribute('aria-label') || (el.querySelector('em')||{}).textContent || '';
      if(lab.indexOf(soldOutWord()) < 0){
        el.setAttribute('aria-label', (lab + ' — ' + soldOutWord()).trim());
      }
    }
  }

  /* The button follows whichever swatch is selected. */
  var sel = -1;
  for(var j=0;j<kids.length;j++){
    if(kids[j].getAttribute('aria-pressed') === 'true'){ sel = j; break; }
  }
  if(sel < 0) return;

  var chosen = fam.products[sel];
  if(!chosen) return;

  if(chosen.available){
    if(add.dataset.qfLabel){ add.textContent = add.dataset.qfLabel; }
    add.disabled = false;
    add.removeAttribute('aria-disabled');
  } else {
    /* Remember the real label once, so it can be restored. */
    if(!add.dataset.qfLabel){ add.dataset.qfLabel = (add.textContent||'').trim(); }
    add.textContent = soldOutWord();
    add.disabled = true;
    add.setAttribute('aria-disabled','true');
  }
}

/* Belt and braces: even if the button is somehow pressed, nothing is added.
   Capture phase runs before the drawer's own handler. */
document.addEventListener('click', function(e){
  var t = e.target;
  if(!t || !t.closest) return;
  var add = t.closest('#qAdd');
  if(!add) return;
  if(add.disabled || add.getAttribute('aria-disabled') === 'true'){
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, true);

function watch(){
  var drawer = document.getElementById('quick');
  if(!drawer) return;
  var queued = false;
  new MutationObserver(function(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; apply(); });
  }).observe(drawer, { childList:true, subtree:true, attributes:true,
                       attributeFilter:['aria-pressed','class'] });
  apply();
}

if(document.readyState === 'complete') watch();
else window.addEventListener('load', watch);
})();